import React from 'react'
import { css, cx } from '@emotion/css'
import { Button } from '@contrast-security-inc/design-system-buttons'
import { Spinner } from '@contrast-security-inc/design-system-loaders'
import { theme } from '@contrast-security-inc/design-system-foundations'

interface Props extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  readonly loading: boolean
}

const innerButtonBodyStyles = css`
  display: flex;
  align-items: center;
  justify-content: center;
`

const spinnerStyles = css`
  margin-right: 5px;
  border: 3px solid ${theme.color.neutral30};
  border-top-color: ${theme.color.neutral50};
`

export class LoadingIndicatorButton extends React.Component<Props, {}> {
  public render() {
    const { loading, children, className, disabled, ...props } = this.props
    return (
      <Button
        isDisabled={disabled || loading}
        data-testid="loading-indicator-button"
        {...props}
        className={cx(
          css`
            height: 34px;
          `,
          className
        )}
      >
        <div className={innerButtonBodyStyles}>
          {loading && <Spinner className={spinnerStyles} size={16} />}
          {children}
        </div>
      </Button>
    )
  }
}
